export enum AuthSource {
    Salesforce = 'salesforce',
    SalesforceWidget = 'salesforce-widget',
    Internal = 'internal',
    AndroidSDK = 'android-sdk',
    IosSDK = 'ios-sdk',
    AppointmentsApplication = 'appointments-application',
    OAuth = 'oauth'
}
